import {Divider, ListItemIcon, ListItemText, MenuItem} from '@mui/material';
import {Gear, SignOut, UserCircle} from '@phosphor-icons/react';
import {selectUserInfo, UserInfo} from '@smartmixin/core';
import {messages} from '@smartmixin/i18n';
import React from 'react';
import isEqual from 'react-fast-compare';
import {useIntl} from 'react-intl';
import {useDispatch, useSelector} from 'react-redux';
import Box from '../../../components/Box';
import RouterLink from '../../../lib/RouterLink';

const AuthenticatedContent = () => {
  const {formatMessage} = useIntl();

  const {email, firstName, lastName} = useSelector<unknown, UserInfo>(
    selectUserInfo,
    isEqual,
  );

  const dispatch = useDispatch();

  const handleLogout = React.useCallback(() => {
    dispatch({type: 'LOGOUT'});
  }, [dispatch]);

  return (
    <>
      <MenuItem component={RouterLink} to="/app/settings/account">
        <ListItemIcon>
          <UserCircle />
        </ListItemIcon>
        <Box>
          <ListItemText
            primary={`${firstName} ${lastName}`}
            secondary={email}
          />
        </Box>
      </MenuItem>
      <Divider />
      <MenuItem component={RouterLink} to="/app/settings">
        <ListItemIcon>
          <Gear />
        </ListItemIcon>
        <ListItemText primary={formatMessage(messages.settings.settings)} />
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <SignOut />
        </ListItemIcon>
        <ListItemText primary={formatMessage(messages.auth.logout)} />
      </MenuItem>
    </>
  );
};

export default AuthenticatedContent;
